const dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299',
};

module.exports.reportData = {
  info: {
    campaignName: 'Goat - FIAFormulaE - Marrakech',
    influencerName: 'Callux (with Calfreezy)',
    reportDate: new Date('2018-02-04'),
    hasLogo: true,
    campaignArchive: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/campaign-archives/callux-fiaformulae-20180204.zip',
  },
  youtubeViews: 305294,
  youtubeEngagements: 20406,
  supportingActivity: [
    {
      platform: 'instagram',
      title: 'Felt famous for the first time ever today, my name was on a console screen ready for me to play.',
      url: 'https://www.instagram.com/p/Bd3A5YCHPIo/',
      views: 223060,
      engagements: 23202,
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1516221560313-WhatsApp_Image_2018_01_17_at_12.52.27_1_.jpeg',
    },
    {
      platform: 'instagram',
      title: 'i broke my phone today but that doesn’t matter',
      url: 'https://www.instagram.com/p/Bd5rTTKnfV7/',
      views: 292768,
      engagements: 37164,
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1516221538392-WhatsApp_Image_2018_01_17_at_12.52.27.jpeg',
    },
    {
      platform: 'twitter',
      url: 'https://twitter.com/callux/status/952261161264787456',
      title: 'My iPhone got brutally run over by a go kart… RIP',
      views: 340959,
      engagements: 78079,
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1516310830907-c0f5467e_86c5_4887_be3d_ec4287288748.jpeg',
    },
    {
      platform: 'instagram',
      title: 'Story 1 - excited for this',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1516221837732-excited_for_this.jpg',
      views: 87389
    },
    {
      platform: 'instagram',
      title: 'Story 2 - I\'m ready for the race',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1516221850013-im_ready_for_the_race.jpg',
      views: 75812
    },
    {
      platform: 'instagram',
      title: 'Story 3 - why the long face cal?',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1516222045423-why_the_long_face_cal.jpg',
      views: 81420
    },
    {
      platform: 'instagram',
      title: 'Story 4 - FFFSSSSSSS',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1516221889106-ffs.jpg',
      views: 70937
    },
    {
      platform: 'instagram',
      title: 'Story 5 - LOL',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1516221898022-LOL.jpg',
      views: 62241
    },
    {
      platform: 'instagram',
      title: 'Story 6 - @fiaformulae #marrakecheprix',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1516221926957-hashtag.jpg',
      views: 71453
    },
    {
      platform: 'instagram',
      title: 'Story 7 - pit stop vid 1',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1516221953613-62807.jpg',
      views: 62807
    },
    {
      platform: 'instagram',
      title: 'Story 8 - pit stop vid 2',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1516221964983-64549.jpg',
      views: 64549
    },
    {
      platform: 'instagram',
      title: 'Story 9 - simulator vid 1',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1516221979418-63692.jpg',
      views: 63692
    },
    {
      platform: 'instagram',
      title: 'Story 10 - simulator vid 2',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1516221991809-61418.jpg',
      views: 61418
    },
    {
      platform: 'instagram',
      title: 'Story 11 - destroyed my phone',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1516222009735-66882.jpg',
      views: 66882
    },
    {
      platform: 'instagram',
      title: 'Story 12 - YouTube video announcement',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1516222009735-66882.jpg',
      views: 62706
    },
    {
      platform: 'twitter',
      url: 'https://twitter.com/Callux/status/957315204559396872',
      title: 'New video coming very very very soon today tonight now',
      views: 112120,
      engagements: 2482,
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1518186195186-WhatsApp_Image_2018_02_06_at_10.08.11.jpeg',
    },
    {
      platform: 'twitter',
      url: 'https://twitter.com/Callux/status/957328105139470336',
      title: 'NEW VIDEO Where have I been?',
      views: 114412,
      engagements: 3204,
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1518186251692-WhatsApp_Image_2018_02_06_at_10.08.10.jpeg',
    },
  ],
  networkActivity: [
    {
      platform: 'twitter',
      influencer: 'Calfreezy',
      followers: '1.3m',
      title: 'Morocco 🇲🇦 📍',
      url: 'https://twitter.com/Calfreezy/status/951508814683045888',
      views: 0,
      engagements: 999,
    },
    {
      platform: 'instagram',
      influencer: 'Calfreezy',
      followers: '1.2m',
      title: 'Quick trip to 🇲🇦 First of the year ⚡️',
      url: 'https://www.instagram.com/p/Bd3Db1NA0db/?taken-by=realcalfreezy',
      views: 0,
      engagements: 41018,
    },
    {
      platform: 'instagram',
      influencer: 'Calfreezy',
      followers: '1.2m',
      title: '14 x INSTAGRAM STORY (over the race weekend)',
      views: 0,
      engagements: 0,
    },
  ],
  heroData: {
    main: {
      title: 'Where have I been?',
      subTitle: 'Check out my grudge race vs Calfreezy and more on Formula E\'s channel: http://bit.ly/2mW5cai',
      videoUrl: 'https://www.youtube.com/watch?v=de0bFvvyMqM',
      views: 305294,
      engagements: 20406,
      watchTimeUKIre: 712956,
      watchTimeTotal: 1155838,
      donutData: {
        labels: [
          'male %',
          'female %',
        ],
        datasets: [{
          data: [91.2, 8.8],
          backgroundColor: [
            dyzioPalette.bgPink,
            dyzioPalette.bgGreen,
          ],
          borderColor: [
            dyzioPalette.pink,
            dyzioPalette.green,
          ],
          borderWidth: 1,
        }],
      },
      barData: {
        labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '64+'],
        datasets: [
          {
            label: 'male %',
            backgroundColor: dyzioPalette.bgPink,
            borderColor: dyzioPalette.pink,
            borderWidth: 1,
            data: [10, 40, 26.7, 7.2, 5.4, 0.8, 1.1],
          },
          {
            label: 'female %',
            backgroundColor: dyzioPalette.bgGreen,
            borderColor: dyzioPalette.green,
            borderWidth: 1,
            data: [1.4, 4.3, 1.6, 0.7, 0.7, 0.1, 0.1],
          },
        ],
      },
      viewingData: [{
        name: 'United Kingdom',
        watchTime: 671636,
        views: 174089,
        likes: 10756,
      },
      {
        name: 'United States',
        watchTime: 93775,
        views: 26168,
        likes: 1775,
      },
      {
        name: 'Australia',
        watchTime: 59898,
        views: 14984,
        likes: 1032,
      },
      {
        name: 'Ireland',
        watchTime: 41320,
        views: 11177,
        likes: 770,
      },
      {
        name: 'Netherlands',
        watchTime: 28915,
        views: 7389,
        likes: 421,
      }
    ],
    },
    supportingData: {
      labels: [
        'instagram',
        'instagram STORY',
        'twitter',
      ],
      datasets: [{
        data: [515828, 831306, 567491],
        backgroundColor: [
          dyzioPalette.bgPink,
          dyzioPalette.bgGreen,
          dyzioPalette.blue,
        ],
        borderColor: [
          dyzioPalette.pink,
          dyzioPalette.green,
          dyzioPalette.bgBlue,
        ],
        borderWidth: 1,
      }],
    },
  },
};



// WEBPACK FOOTER //
// ./src/containers/campaign-report/data/callux-FIAFormulaE-2018.js